export const countries = [
  { code: 1, name: 'Estados Unidos', textCode: 'US' },
  { code: 7, name: 'Rusia', textCode: 'RU' },
  { code: 20, name: 'Egipto', textCode: 'EG' },
  { code: 27, name: 'Sudáfrica', textCode: 'ZA' },
  { code: 30, name: 'Grecia', textCode: 'GR' },
  { code: 31, name: 'Países Bajos', textCode: 'NL' },
  { code: 32, name: 'Bélgica', textCode: 'BE' },
  { code: 33, name: 'Francia', textCode: 'FR' },
  { code: 34, name: 'España', textCode: 'ES' },
  { code: 36, name: 'Hungría', textCode: 'HU' },
  { code: 39, name: 'Italia', textCode: 'IT' },
  { code: 40, name: 'Rumanía', textCode: 'RO' },
  { code: 41, name: 'Suiza', textCode: 'CH' },
  { code: 43, name: 'Austria', textCode: 'AT' },
  { code: 44, name: 'Reino Unido', textCode: 'GB' },
  { code: 45, name: 'Dinamarca', textCode: 'DK' },
  { code: 46, name: 'Suecia', textCode: 'SE' },
  { code: 47, name: 'Noruega', textCode: 'NO' },
  { code: 48, name: 'Polonia', textCode: 'PL' },
  { code: 49, name: 'Alemania', textCode: 'DE' },
  { code: 51, name: 'Perú', textCode: 'PE' },
  { code: 52, name: 'México', textCode: 'MX' },
  { code: 53, name: 'Cuba', textCode: 'CU' },
  { code: 54, name: 'Argentina', textCode: 'AR' },
  { code: 55, name: 'Brasil', textCode: 'BR' },
  { code: 56, name: 'Chile', textCode: 'CL' },
  { code: 57, name: 'Colombia', textCode: 'CO' },
  { code: 58, name: 'Venezuela', textCode: 'VE' },
  { code: 60, name: 'Malasia', textCode: 'MY' },
  { code: 61, name: 'Australia', textCode: 'AU' },
  { code: 62, name: 'Indonesia', textCode: 'ID' },
  { code: 63, name: 'Filipinas', textCode: 'PH' },
  { code: 64, name: 'Nueva Zelanda', textCode: 'NZ' },
  { code: 65, name: 'Singapur', textCode: 'SG' },
  { code: 66, name: 'Tailandia', textCode: 'TH' },
  { code: 81, name: 'Japón', textCode: 'JP' },
  { code: 82, name: 'Corea del Sur', textCode: 'KR' },
  { code: 84, name: 'Vietnam', textCode: 'VN' },
  { code: 86, name: 'China', textCode: 'CN' },
  { code: 90, name: 'Turquía', textCode: 'TR' },
  { code: 91, name: 'India', textCode: 'IN' },
  { code: 92, name: 'Pakistán', textCode: 'PK' },
  { code: 93, name: 'Afganistán', textCode: 'AF' },
  { code: 94, name: 'Sri Lanka', textCode: 'LK' },
  { code: 95, name: 'Myanmar', textCode: 'MM' },
  { code: 98, name: 'Irán', textCode: 'IR' },
  { code: 211, name: 'Sudán del Sur', textCode: 'SS' },
  { code: 212, name: 'Marruecos', textCode: 'MA' },
  { code: 213, name: 'Argelia', textCode: 'DZ' },
  { code: 216, name: 'Túnez', textCode: 'TN' },
  { code: 218, name: 'Libia', textCode: 'LY' },
  { code: 220, name: 'Gambia', textCode: 'GM' },
  { code: 221, name: 'Senegal', textCode: 'SN' },
  { code: 222, name: 'Mauritania', textCode: 'MR' },
  { code: 223, name: 'Malí', textCode: 'ML' },
  { code: 224, name: 'Guinea', textCode: 'GN' },
  { code: 225, name: 'Costa de Marfil', textCode: 'CI' },
  { code: 226, name: 'Burkina Faso', textCode: 'BF' },
  { code: 227, name: 'Níger', textCode: 'NE' },
  { code: 228, name: 'Togo', textCode: 'TG' },
  { code: 229, name: 'Benín', textCode: 'BJ' },
  { code: 230, name: 'Mauricio', textCode: 'MU' },
  { code: 231, name: 'Liberia', textCode: 'LR' },
  { code: 232, name: 'Sierra Leona', textCode: 'SL' },
  { code: 233, name: 'Ghana', textCode: 'GH' },
  { code: 234, name: 'Nigeria', textCode: 'NG' },
  { code: 235, name: 'Chad', textCode: 'TD' },
  { code: 236, name: 'República Centroafricana', textCode: 'CF' },
  { code: 237, name: 'Camerún', textCode: 'CM' },
  { code: 238, name: 'Cabo Verde', textCode: 'CV' },
  { code: 239, name: 'Santo Tomé y Príncipe', textCode: 'ST' },
  { code: 240, name: 'Guinea Ecuatorial', textCode: 'GQ' },
  { code: 241, name: 'Gabón', textCode: 'GA' },
  { code: 242, name: 'República del Congo', textCode: 'CG' },
  { code: 243, name: 'República Democrática del Congo', textCode: 'CD' },
  { code: 244, name: 'Angola', textCode: 'AO' },
  { code: 245, name: 'Guinea-Bisáu', textCode: 'GW' },
  { code: 246, name: 'Territorio Británico del Océano Índico', textCode: 'IO' },
  { code: 248, name: 'Seychelles', textCode: 'SC' },
  { code: 249, name: 'Sudán', textCode: 'SD' },
  { code: 250, name: 'Ruanda', textCode: 'RW' },
  { code: 251, name: 'Etiopía', textCode: 'ET' },
  { code: 252, name: 'Somalia', textCode: 'SO' },
  { code: 253, name: 'Yibuti', textCode: 'DJ' },
  { code: 254, name: 'Kenia', textCode: 'KE' },
  { code: 255, name: 'Tanzania', textCode: 'TZ' },
  { code: 256, name: 'Uganda', textCode: 'UG' },
  { code: 257, name: 'Burundi', textCode: 'BI' },
  { code: 258, name: 'Mozambique', textCode: 'MZ' },
  { code: 260, name: 'Zambia', textCode: 'ZM' },
  { code: 261, name: 'Madagascar', textCode: 'MG' },
  { code: 262, name: 'Reunión', textCode: 'RE' },
  { code: 263, name: 'Zimbabue', textCode: 'ZW' },
  { code: 264, name: 'Namibia', textCode: 'NA' },
  { code: 265, name: 'Malaui', textCode: 'MW' },
  { code: 266, name: 'Lesoto', textCode: 'LS' },
  { code: 267, name: 'Botsuana', textCode: 'BW' },
  { code: 268, name: 'Esuatini', textCode: 'SZ' },
  { code: 269, name: 'Comoras', textCode: 'KM' },
  { code: 290, name: 'Santa Elena', textCode: 'SH' },
  { code: 291, name: 'Eritrea', textCode: 'ER' },
  { code: 297, name: 'Aruba', textCode: 'AW' },
  { code: 298, name: 'Islas Feroe', textCode: 'FO' },
  { code: 299, name: 'Groenlandia', textCode: 'GL' },
  { code: 350, name: 'Gibraltar', textCode: 'GI' },
  { code: 351, name: 'Portugal', textCode: 'PT' },
  { code: 352, name: 'Luxemburgo', textCode: 'LU' },
  { code: 353, name: 'Irlanda', textCode: 'IE' },
  { code: 354, name: 'Islandia', textCode: 'IS' },
  { code: 355, name: 'Albania', textCode: 'AL' },
  { code: 356, name: 'Malta', textCode: 'MT' },
  { code: 357, name: 'Chipre', textCode: 'CY' },
  { code: 358, name: 'Finlandia', textCode: 'FI' },
  { code: 359, name: 'Bulgaria', textCode: 'BG' },
  { code: 370, name: 'Lituania', textCode: 'LT' },
  { code: 371, name: 'Letonia', textCode: 'LV' },
  { code: 372, name: 'Estonia', textCode: 'EE' },
  { code: 373, name: 'Moldavia', textCode: 'MD' },
  { code: 374, name: 'Armenia', textCode: 'AM' },
  { code: 375, name: 'Bielorrusia', textCode: 'BY' },
  { code: 376, name: 'Andorra', textCode: 'AD' },
  { code: 377, name: 'Mónaco', textCode: 'MC' },
  { code: 378, name: 'San Marino', textCode: 'SM' },
  { code: 379, name: 'Ciudad del Vaticano', textCode: 'VA' },
  { code: 380, name: 'Ucrania', textCode: 'UA' },
  { code: 381, name: 'Serbia', textCode: 'RS' },
  { code: 382, name: 'Montenegro', textCode: 'ME' },
  { code: 383, name: 'Kosovo', textCode: 'XK' },
  { code: 385, name: 'Croacia', textCode: 'HR' },
  { code: 386, name: 'Eslovenia', textCode: 'SI' },
  { code: 387, name: 'Bosnia y Herzegovina', textCode: 'BA' },
  { code: 389, name: 'Macedonia del Norte', textCode: 'MK' },
  { code: 420, name: 'República Checa', textCode: 'CZ' },
  { code: 421, name: 'Eslovaquia', textCode: 'SK' },
  { code: 423, name: 'Liechtenstein', textCode: 'LI' },
  { code: 500, name: 'Islas Malvinas', textCode: 'FK' },
  { code: 501, name: 'Belice', textCode: 'BZ' },
  { code: 502, name: 'Guatemala', textCode: 'GT' },
  { code: 503, name: 'El Salvador', textCode: 'SV' },
  { code: 504, name: 'Honduras', textCode: 'HN' },
  { code: 505, name: 'Nicaragua', textCode: 'NI' },
  { code: 506, name: 'Costa Rica', textCode: 'CR' },
  { code: 507, name: 'Panamá', textCode: 'PA' },
  { code: 508, name: 'San Pedro y Miquelón', textCode: 'PM' },
  { code: 509, name: 'Haití', textCode: 'HT' },
  { code: 590, name: 'Guadalupe', textCode: 'GP' },
  { code: 591, name: 'Bolivia', textCode: 'BO' },
  { code: 592, name: 'Guyana', textCode: 'GY' },
  { code: 593, name: 'Ecuador', textCode: 'EC' },
  { code: 594, name: 'Guayana Francesa', textCode: 'GF' },
  { code: 595, name: 'Paraguay', textCode: 'PY' },
  { code: 596, name: 'Martinica', textCode: 'MQ' },
  { code: 597, name: 'Surinam', textCode: 'SR' },
  { code: 598, name: 'Uruguay', textCode: 'UY' },
  { code: 599, name: 'Curazao', textCode: 'CW' },
  { code: 670, name: 'Timor Oriental', textCode: 'TL' },
  { code: 672, name: 'Antártida', textCode: 'AQ' },
  { code: 673, name: 'Brunéi', textCode: 'BN' },
  { code: 674, name: 'Nauru', textCode: 'NR' },
  { code: 675, name: 'Papúa Nueva Guinea', textCode: 'PG' },
  { code: 676, name: 'Tonga', textCode: 'TO' },
  { code: 677, name: 'Islas Salomón', textCode: 'SB' },
  { code: 678, name: 'Vanuatu', textCode: 'VU' },
  { code: 679, name: 'Fiyi', textCode: 'FJ' },
  { code: 680, name: 'Palaos', textCode: 'PW' },
  { code: 681, name: 'Wallis y Futuna', textCode: 'WF' },
  { code: 682, name: 'Islas Cook', textCode: 'CK' },
  { code: 683, name: 'Niue', textCode: 'NU' },
  { code: 685, name: 'Samoa', textCode: 'WS' },
  { code: 686, name: 'Kiribati', textCode: 'KI' },
  { code: 687, name: 'Nueva Caledonia', textCode: 'NC' },
  { code: 688, name: 'Tuvalu', textCode: 'TV' },
  { code: 689, name: 'Polinesia Francesa', textCode: 'PF' },
  { code: 690, name: 'Tokelau', textCode: 'TK' },
  { code: 691, name: 'Micronesia', textCode: 'FM' },
  { code: 692, name: 'Islas Marshall', textCode: 'MH' },
  { code: 850, name: 'Corea del Norte', textCode: 'KP' },
  { code: 852, name: 'Hong Kong', textCode: 'HK' },
  { code: 853, name: 'Macao', textCode: 'MO' },
  { code: 855, name: 'Camboya', textCode: 'KH' },
  { code: 856, name: 'Laos', textCode: 'LA' },
  { code: 880, name: 'Bangladés', textCode: 'BD' },
  { code: 886, name: 'Taiwán', textCode: 'TW' },
  { code: 960, name: 'Maldivas', textCode: 'MV' },
  { code: 961, name: 'Líbano', textCode: 'LB' },
  { code: 962, name: 'Jordania', textCode: 'JO' },
  { code: 963, name: 'Siria', textCode: 'SY' },
  { code: 964, name: 'Irak', textCode: 'IQ' },
  { code: 965, name: 'Kuwait', textCode: 'KW' },
  { code: 966, name: 'Arabia Saudita', textCode: 'SA' },
  { code: 967, name: 'Yemen', textCode: 'YE' },
  { code: 968, name: 'Omán', textCode: 'OM' },
  { code: 970, name: 'Palestina', textCode: 'PS' },
  { code: 971, name: 'Emiratos Árabes Unidos', textCode: 'AE' },
  { code: 972, name: 'Israel', textCode: 'IL' },
  { code: 973, name: 'Baréin', textCode: 'BH' },
  { code: 974, name: 'Catar', textCode: 'QA' },
  { code: 975, name: 'Bután', textCode: 'BT' },
  { code: 976, name: 'Mongolia', textCode: 'MN' },
  { code: 977, name: 'Nepal', textCode: 'NP' },
  { code: 992, name: 'Tayikistán', textCode: 'TJ' },
  { code: 993, name: 'Turkmenistán', textCode: 'TM' },
  { code: 994, name: 'Azerbaiyán', textCode: 'AZ' },
  { code: 995, name: 'Georgia', textCode: 'GE' },
  { code: 996, name: 'Kirguistán', textCode: 'KG' },
  { code: 998, name: 'Uzbekistán', textCode: 'UZ' },
  { code: 1242, name: 'Bahamas', textCode: 'BS' },
  { code: 1246, name: 'Barbados', textCode: 'BB' },
  { code: 1264, name: 'Anguila', textCode: 'AI' },
  { code: 1268, name: 'Antigua y Barbuda', textCode: 'AG' },
  { code: 1284, name: 'Islas Vírgenes Británicas', textCode: 'VG' },
  { code: 1340, name: 'Islas Vírgenes de los Estados Unidos', textCode: 'VI' },
  { code: 1441, name: 'Bermudas', textCode: 'BM' },
  { code: 1473, name: 'Granada', textCode: 'GD' },
  { code: 1649, name: 'Islas Turcas y Caicos', textCode: 'TC' },
  { code: 1664, name: 'Montserrat', textCode: 'MS' },
  { code: 1670, name: 'Islas Marianas del Norte', textCode: 'MP' },
  { code: 1671, name: 'Guam', textCode: 'GU' },
  { code: 1684, name: 'Samoa Americana', textCode: 'AS' },
  { code: 1721, name: 'Sint Maarten', textCode: 'SX' },
  { code: 1758, name: 'Santa Lucía', textCode: 'LC' },
  { code: 1767, name: 'Dominica', textCode: 'DM' },
  { code: 1784, name: 'San Vicente y las Granadinas', textCode: 'VC' },
  { code: 1787, name: 'Puerto Rico', textCode: 'PR' },
  { code: 1809, name: 'República Dominicana', textCode: 'DO' },
  { code: 1868, name: 'Trinidad y Tobago', textCode: 'TT' },
  { code: 1869, name: 'San Cristóbal y Nieves', textCode: 'KN' },
  { code: 1876, name: 'Jamaica', textCode: 'JM' },
  { code: 2112, name: 'Sudán del Sur', textCode: 'SS' },
  { code: 2121, name: 'Marruecos', textCode: 'MA' },
  { code: 2131, name: 'Argelia', textCode: 'DZ' },
  { code: 2161, name: 'Túnez', textCode: 'TN' },
  { code: 2181, name: 'Libia', textCode: 'LY' },
  { code: 2201, name: 'Gambia', textCode: 'GM' },
  { code: 2211, name: 'Senegal', textCode: 'SN' },
  { code: 2221, name: 'Mauritania', textCode: 'MR' },
  { code: 2231, name: 'Malí', textCode: 'ML' },
  { code: 2241, name: 'Guinea', textCode: 'GN' },
  { code: 2251, name: 'Costa de Marfil', textCode: 'CI' },
  { code: 2261, name: 'Burkina Faso', textCode: 'BF' },
  { code: 2271, name: 'Níger', textCode: 'NE' },
  { code: 2281, name: 'Togo', textCode: 'TG' },
  { code: 2291, name: 'Benín', textCode: 'BJ' },
  { code: 2301, name: 'Mauricio', textCode: 'MU' },
  { code: 2311, name: 'Liberia', textCode: 'LR' },
  { code: 2321, name: 'Sierra Leona', textCode: 'SL' },
  { code: 2331, name: 'Ghana', textCode: 'GH' },
  { code: 2341, name: 'Nigeria', textCode: 'NG' },
  { code: 2351, name: 'Chad', textCode: 'TD' },
  { code: 2361, name: 'República Centroafricana', textCode: 'CF' },
  { code: 2371, name: 'Camerún', textCode: 'CM' },
  { code: 2381, name: 'Cabo Verde', textCode: 'CV' },
  { code: 2391, name: 'Santo Tomé y Príncipe', textCode: 'ST' },
  { code: 2401, name: 'Guinea Ecuatorial', textCode: 'GQ' },
  { code: 2411, name: 'Gabón', textCode: 'GA' },
  { code: 2421, name: 'República del Congo', textCode: 'CG' },
  { code: 2431, name: 'República Democrática del Congo', textCode: 'CD' },
  { code: 2441, name: 'Angola', textCode: 'AO' },
  { code: 2451, name: 'Guinea-Bisáu', textCode: 'GW' },
  {
    code: 2461,
    name: 'Territorio Británico del Océano Índico',
    textCode: 'IO',
  },
  { code: 2481, name: 'Seychelles', textCode: 'SC' },
  { code: 2491, name: 'Sudán', textCode: 'SD' },
  { code: 2501, name: 'Ruanda', textCode: 'RW' },
  { code: 2511, name: 'Etiopía', textCode: 'ET' },
  { code: 2521, name: 'Somalia', textCode: 'SO' },
  { code: 2531, name: 'Yibuti', textCode: 'DJ' },
  { code: 2541, name: 'Kenia', textCode: 'KE' },
  { code: 2551, name: 'Tanzania', textCode: 'TZ' },
  { code: 2561, name: 'Uganda', textCode: 'UG' },
  { code: 2571, name: 'Burundi', textCode: 'BI' },
  { code: 2581, name: 'Mozambique', textCode: 'MZ' },
  { code: 2601, name: 'Zambia', textCode: 'ZM' },
  { code: 2611, name: 'Madagascar', textCode: 'MG' },
  { code: 2621, name: 'Reunión', textCode: 'RE' },
  { code: 2631, name: 'Zimbabue', textCode: 'ZW' },
  { code: 2641, name: 'Namibia', textCode: 'NA' },
  { code: 2651, name: 'Malaui', textCode: 'MW' },
  { code: 2661, name: 'Lesoto', textCode: 'LS' },
  { code: 2671, name: 'Botsuana', textCode: 'BW' },
  { code: 2681, name: 'Esuatini', textCode: 'SZ' },
  { code: 2691, name: 'Comoras', textCode: 'KM' },
  { code: 2901, name: 'Santa Elena', textCode: 'SH' },
  { code: 2911, name: 'Eritrea', textCode: 'ER' },
  { code: 2971, name: 'Aruba', textCode: 'AW' },
  { code: 2981, name: 'Islas Feroe', textCode: 'FO' },
  { code: 2991, name: 'Groenlandia', textCode: 'GL' },
  { code: 3501, name: 'Gibraltar', textCode: 'GI' },
  { code: 3511, name: 'Portugal', textCode: 'PT' },
  { code: 3521, name: 'Luxemburgo', textCode: 'LU' },
  { code: 3531, name: 'Irlanda', textCode: 'IE' },
  { code: 3541, name: 'Islandia', textCode: 'IS' },
  { code: 3551, name: 'Albania', textCode: 'AL' },
  { code: 3561, name: 'Malta', textCode: 'MT' },
  { code: 3571, name: 'Chipre', textCode: 'CY' },
  { code: 3581, name: 'Finlandia', textCode: 'FI' },
  { code: 3591, name: 'Bulgaria', textCode: 'BG' },
  { code: 3701, name: 'Lituania', textCode: 'LT' },
  { code: 3711, name: 'Letonia', textCode: 'LV' },
  { code: 3721, name: 'Estonia', textCode: 'EE' },
  { code: 3731, name: 'Moldavia', textCode: 'MD' },
  { code: 3741, name: 'Armenia', textCode: 'AM' },
  { code: 3751, name: 'Bielorrusia', textCode: 'BY' },
  { code: 3761, name: 'Andorra', textCode: 'AD' },
  { code: 3771, name: 'Mónaco', textCode: 'MC' },
  { code: 3781, name: 'San Marino', textCode: 'SM' },
  { code: 3791, name: 'Ciudad del Vaticano', textCode: 'VA' },
  { code: 3801, name: 'Ucrania', textCode: 'UA' },
  { code: 3811, name: 'Serbia', textCode: 'RS' },
  { code: 3821, name: 'Montenegro', textCode: 'ME' },
  { code: 3831, name: 'Kosovo', textCode: 'XK' },
  { code: 3851, name: 'Croacia', textCode: 'HR' },
  { code: 3861, name: 'Eslovenia', textCode: 'SI' },
  { code: 3871, name: 'Bosnia y Herzegovina', textCode: 'BA' },
  { code: 3891, name: 'Macedonia del Norte', textCode: 'MK' },
  { code: 4201, name: 'República Checa', textCode: 'CZ' },
  { code: 4211, name: 'Eslovaquia', textCode: 'SK' },
  { code: 4231, name: 'Liechtenstein', textCode: 'LI' },
  { code: 5001, name: 'Islas Malvinas', textCode: 'FK' },
  { code: 5011, name: 'Belice', textCode: 'BZ' },
  { code: 5021, name: 'Guatemala', textCode: 'GT' },
  { code: 5031, name: 'El Salvador', textCode: 'SV' },
  { code: 5041, name: 'Honduras', textCode: 'HN' },
  { code: 5051, name: 'Nicaragua', textCode: 'NI' },
  { code: 5061, name: 'Costa Rica', textCode: 'CR' },
  { code: 5071, name: 'Panamá', textCode: 'PA' },
  { code: 5081, name: 'San Pedro y Miquelón', textCode: 'PM' },
  { code: 5091, name: 'Haití', textCode: 'HT' },
  { code: 5901, name: 'Guadalupe', textCode: 'GP' },
  { code: 5911, name: 'Bolivia', textCode: 'BO' },
  { code: 5921, name: 'Guyana', textCode: 'GY' },
  { code: 5931, name: 'Ecuador', textCode: 'EC' },
  { code: 5941, name: 'Guayana Francesa', textCode: 'GF' },
  { code: 5951, name: 'Paraguay', textCode: 'PY' },
  { code: 5961, name: 'Martinica', textCode: 'MQ' },
  { code: 5971, name: 'Surinam', textCode: 'SR' },
  { code: 5981, name: 'Uruguay', textCode: 'UY' },
  { code: 5991, name: 'Curazao', textCode: 'CW' },
  { code: 6701, name: 'Timor Oriental', textCode: 'TL' },
  { code: 6721, name: 'Antártida', textCode: 'AQ' },
  { code: 6731, name: 'Brunéi', textCode: 'BN' },
  { code: 6741, name: 'Nauru', textCode: 'NR' },
  { code: 6751, name: 'Papúa Nueva Guinea', textCode: 'PG' },
  { code: 6761, name: 'Tonga', textCode: 'TO' },
  { code: 6771, name: 'Islas Salomón', textCode: 'SB' },
  { code: 6781, name: 'Vanuatu', textCode: 'VU' },
  { code: 6791, name: 'Fiyi', textCode: 'FJ' },
  { code: 6801, name: 'Palaos', textCode: 'PW' },
  { code: 6811, name: 'Wallis y Futuna', textCode: 'WF' },
  { code: 6821, name: 'Islas Cook', textCode: 'CK' },
  { code: 6831, name: 'Niue', textCode: 'NU' },
  { code: 6851, name: 'Samoa', textCode: 'WS' },
  { code: 6861, name: 'Kiribati', textCode: 'KI' },
  { code: 6871, name: 'Nueva Caledonia', textCode: 'NC' },
  { code: 6881, name: 'Tuvalu', textCode: 'TV' },
  { code: 6891, name: 'Polinesia Francesa', textCode: 'PF' },
  { code: 6901, name: 'Tokelau', textCode: 'TK' },
  { code: 6911, name: 'Micronesia', textCode: 'FM' },
  { code: 6921, name: 'Islas Marshall', textCode: 'MH' },
  { code: 8501, name: 'Corea del Norte', textCode: 'KP' },
  { code: 8521, name: 'Hong Kong', textCode: 'HK' },
  { code: 8531, name: 'Macao', textCode: 'MO' },
  { code: 8551, name: 'Camboya', textCode: 'KH' },
  { code: 8561, name: 'Laos', textCode: 'LA' },
  { code: 8801, name: 'Bangladés', textCode: 'BD' },
  { code: 8861, name: 'Taiwán', textCode: 'TW' },
  { code: 9601, name: 'Maldivas', textCode: 'MV' },
  { code: 9611, name: 'Líbano', textCode: 'LB' },
  { code: 9621, name: 'Jordania', textCode: 'JO' },
  { code: 9631, name: 'Siria', textCode: 'SY' },
  { code: 9641, name: 'Irak', textCode: 'IQ' },
  { code: 9651, name: 'Kuwait', textCode: 'KW' },
  { code: 9661, name: 'Arabia Saudita', textCode: 'SA' },
  { code: 9671, name: 'Yemen', textCode: 'YE' },
  { code: 9681, name: 'Omán', textCode: 'OM' },
  { code: 9701, name: 'Palestina', textCode: 'PS' },
  { code: 9711, name: 'Emiratos Árabes Unidos', textCode: 'AE' },
  { code: 9721, name: 'Israel', textCode: 'IL' },
  { code: 9731, name: 'Baréin', textCode: 'BH' },
  { code: 9741, name: 'Catar', textCode: 'QA' },
  { code: 9751, name: 'Bután', textCode: 'BT' },
  { code: 9761, name: 'Mongolia', textCode: 'MN' },
  { code: 9771, name: 'Nepal', textCode: 'NP' },
]
